export default "/images/framework/Badge_11.7fcbcbee.svg?7fcbcbee";